import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AuthService } from '../services/AuthService/auth.service';

@Injectable({ providedIn: 'root' })
export class AppGuard {
  constructor(
    private readonly authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> | boolean {
    if (this.authService.isAuthenticatedAndTokenValid()) {
      return this.authService.refreshPermissoes().pipe(
        map(() => true),
        catchError(() => of(true))
      );
    }

    this.authService.logout();
    return false;
  }
}
